import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { ROUTE_SOURCES } from 'src/constants/routeSources';

/** Stessi blocchi Contact + Footer della home marketing (riuso su blog e altre pagine pubbliche). */
const ContactSection = styled(Box)(() => ({
  padding: '80px 10%',
  backgroundColor: '#090f16',
  textAlign: 'center',
  width: '100%',
  boxSizing: 'border-box',
}));

const ContactTitle = styled(Typography)(() => ({
  color: 'rgb(30, 237, 159)',
  fontSize: '1.8rem',
  marginBottom: '20px',
}));

const ContactText = styled(Typography)(() => ({
  color: '#d2d2d2',
  fontSize: '1rem',
}));

const ContactLink = styled('a')(() => ({
  color: 'rgb(30, 237, 159)',
  textDecoration: 'none',
}));

const Footer = styled(Box)(() => ({
  padding: '30px 10% 60px 10%',
  backgroundColor: '#060b11',
  textAlign: 'center',
  fontSize: '0.9rem',
  color: '#aaa',
  width: '100%',
  boxSizing: 'border-box',
  borderTop: '1px solid rgba(255, 255, 255, 0.06)',
}));

const FooterLink = styled('button')(() => ({
  color: '#aaa',
  textDecoration: 'none',
  margin: '0 15px',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  font: 'inherit',
  padding: 0,
  '&:hover': {
    color: 'rgb(30, 237, 159)',
  },
}));

export const PublicMarketingFooter: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <ContactSection>
        <ContactTitle>Contact Us</ContactTitle>
        <ContactText>
          For inquiries, reach out at{' '}
          <ContactLink href="mailto:hr@kipify.io">hr@kipify.io</ContactLink>
        </ContactText>
      </ContactSection>

      <Footer component="footer">
        <Box sx={{ marginBottom: '15px' }}>
          Kipify S.R.L. Partita IVA 03912000548, Via della Treggia 42,b, Perugia
          (PG)
        </Box>
        <Box sx={{ marginBottom: '15px' }}>
          <FooterLink
            type="button"
            onClick={() => navigate(`/${ROUTE_SOURCES.PRIVACY}`)}
          >
            Privacy Policy
          </FooterLink>
          <FooterLink
            type="button"
            onClick={() => navigate(`/${ROUTE_SOURCES.TERMS}`)}
          >
            Termini e Condizioni
          </FooterLink>
        </Box>
        <Box sx={{ fontSize: '0.8rem', color: '#888', marginBottom: '10px' }}>
          Start your free 14-day trial today • No credit card required
        </Box>
        <Box sx={{ fontSize: '0.8rem', color: '#888' }}>
          © 2024 Kipify S.R.L. Tutti i diritti riservati
        </Box>
      </Footer>
    </>
  );
};
